"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguageDropDown = void 0;
var _react = _interopRequireDefault(require("react"));
var _Earth = _interopRequireDefault(require("@berlitz/streamline-icons/lib/regular/48-Maps-Navigation/13-Earth/Earth3"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _MobileNav = require("./MobileNav.style");
var _LanguageDropDown = require("./LanguageDropDown.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var dataKeyBase = 'max-mobile-nav';
var Title = function Title(_ref) {
  var activeLanguage = _ref.activeLanguage;
  return /*#__PURE__*/_react.default.createElement(_LanguageDropDown.TitleWrapper, null, /*#__PURE__*/_react.default.createElement(_spacer.default, {
    noTop: true,
    noLeft: true,
    noBottom: true
  }, /*#__PURE__*/_react.default.createElement(_Earth.default, {
    color: "ui01"
  })), activeLanguage);
};
var LanguageDropDown = function LanguageDropDown(_ref2) {
  var languageLinks = _ref2.languageLinks,
    activeLanguage = _ref2.activeLanguage;
  return /*#__PURE__*/_react.default.createElement("li", {
    key: "".concat(dataKeyBase, "-language--dropdown"),
    "data-key": "".concat(dataKeyBase, "-language--dropdown")
  }, /*#__PURE__*/_react.default.createElement(_LanguageDropDown.StyledExpander, {
    border: false,
    icon: true,
    title: /*#__PURE__*/_react.default.createElement(Title, {
      activeLanguage: activeLanguage
    })
  }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileSubLinks, {
    "data-key": "".concat(dataKeyBase, "-language--sub-links")
  }, languageLinks.map(function (subLink, subIndex) {
    return /*#__PURE__*/_react.default.createElement(_MobileNav.SubNavItem, {
      subLink: true,
      key: "sub-nav-item-language-".concat(subIndex),
      "data-key": "".concat(dataKeyBase, "-language-sub-item-").concat(subIndex)
    }, subLink);
  }))));
};
exports.LanguageDropDown = LanguageDropDown;
var _default = LanguageDropDown;
exports.default = _default;